import React from "react";
import { Container, Typography, Card, CardContent, Grid, CardMedia, Box } from "@mui/material";
import { motion } from "framer-motion";
import Carousel from "react-material-ui-carousel";

const products = [
  { 
    name: "Industrial Boiler", 
    img: "https://www.rasmech.com/wp-content/uploads/2020/11/D-Style-5.jpg", 
    description: "High-efficiency steam boilers for industrial applications." 
  },
  { 
    name: "Pressure Vessel", 
    img: "https://th.bing.com/th/id/R.5628bdac05ec5553222b488df7a97a44?rik=GaRSxsH5qMfH%2fA&riu=http%3a%2f%2fwww.titanmf.com%2fwp-content%2fuploads%2f2014%2f03%2fZirconium-702-Pressure-Vessel-001.jpg&ehk=q4zMakWLCSypSnX4tECj%2b7G14erL8VIJP02Xnxld%2bYE%3d&risl=&pid=ImgRaw&r=0", 
    description: "Durable pressure vessels for safe fluid storage." 
  },
  { 
    name: "Heat Exchanger", 
    img: "https://savree-storage.s3.amazonaws.com/Articles/optimised/heat-exchanger-course-image-min.jpg", 
    description: "Advanced heat exchangers for optimized energy transfer." 
  }
];

const projects = [
  { 
    title: "Mega Refinery Project", 
    img: "https://www.rasmech.com/wp-content/uploads/2020/11/D-Style-5.jpg", 
    details: "Successful deployment of high-capacity boilers in an oil refinery." 
  },
  { 
    title: "Power Plant Integration", 
    img: "https://th.bing.com/th/id/R.5628bdac05ec5553222b488df7a97a44?rik=GaRSxsH5qMfH%2fA&riu=http%3a%2f%2fwww.titanmf.com%2fwp-content%2fuploads%2f2014%2f03%2fZirconium-702-Pressure-Vessel-001.jpg&ehk=q4zMakWLCSypSnX4tECj%2b7G14erL8VIJP02Xnxld%2bYE%3d&risl=&pid=ImgRaw&r=0", 
    details: "Installation of advanced pressure vessels in a power generation facility." 
  }
];

function ProductsServicesContent() {
  return (
    <Container maxWidth="lg">
      {/* Header */}
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>
        <Typography variant="h4" align="center" gutterBottom>
          🏭 Products & Services
        </Typography>
      </motion.div>

      {/* Product Catalog */}
      <Box mt={4}>
        <motion.div initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.6 }}>
          <Typography variant="h5" gutterBottom>
            🛠️ Our Products
          </Typography>
        </motion.div>
        <Grid container spacing={4}>
          {products.map((product, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 200 }}>
                <Card elevation={3}>
                  <CardMedia component="img" height="200" image={product.img} alt={product.name} />
                  <CardContent>
                    <Typography variant="h6">{product.name}</Typography>
                    <Typography variant="body2">{product.description}</Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Project Highlights */}
      <Box mt={5}>
        <motion.div initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.6 }}>
          <Typography variant="h5" gutterBottom>
            🚀 Project Highlights
          </Typography>
        </motion.div>
        <Carousel>
          {projects.map((project, index) => (
            <Card key={index} elevation={3}>
              <CardMedia component="img" height="300" image={project.img} alt={project.title} />
              <CardContent>
                <Typography variant="h6">{project.title}</Typography>
                <Typography variant="body2">{project.details}</Typography>
              </CardContent>
            </Card>
          ))}
        </Carousel>
      </Box>
    </Container>
  );
}

export default ProductsServicesContent;
